import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import AccountCard from './AccountCard';
import { accountCardStyles } from './styles';
import AddOrEditAccount from './AddOrEditAccount';

export default function AccountsList() {
  const [isLoading, setIsLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewAccountModalOpen, setAddNewAccountModalOpen] = useState(false);

  const getAccounts = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/account/?search=${searchText}`)
      .then(res => {
        setAccounts(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewAccountModalClose = () => {
    getAccounts();
    setAddNewAccountModalOpen(false);
  };

  useEffect(() => {
    // Fetch accounts on mount
    getAccounts();
  }, [getAccounts]);

  return (
    <>
      <SearchBar label="Search an account..." setQuery={setSearchText} />
      <div style={accountCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewAccountModalOpen(true)}>
          Account
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={accounts}
            emptyMessage="No accounts found."
            // @ts-ignore
            CardComponent={AccountCard}
            onAccountDelete={getAccounts}
            onAccountUpdate={getAccounts}
          />
          <AddOrEditAccount
            onSave={onNewAccountModalClose}
            modalTitle="Add new account"
            isModalOpen={addNewAccountModalOpen}
            setModalOpen={setAddNewAccountModalOpen}
          />
        </>
      )}
    </>
  );
}
